import { CONTACT } from './index';
import { Action } from '../action';

export class ContactInitAction implements Action {
	readonly type = CONTACT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContactDestroyAction implements Action {
	readonly type = CONTACT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContactSubmitFormAction implements Action {
	readonly type = CONTACT.SUBMIT_FORM;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class ContactSubmitFormSuccessAction implements Action {
	readonly type = CONTACT.SUBMIT_FORM_SUCCESS;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class ContactSubmitFormFailureAction implements Action {
	readonly type = CONTACT.SUBMIT_FORM_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
